import { type SelectOptionJSON } from '@databases/model/field';
import { v4 as uuidv4 } from 'uuid';

import { pickNewColor } from './get-new-color-suggestions.ts';

type SelectOptionResolution =
  | { kind: 'existing'; optionId: string }
  | { kind: 'new'; option: SelectOptionJSON; optionId: string };

export function findOrBuildSelectOption(
  options: SelectOptionJSON[],
  label: string
): SelectOptionResolution {
  const existingOption = options.find((option) => option.label === label);

  if (existingOption) {
    return { kind: 'existing', optionId: existingOption.id };
  }

  const option: SelectOptionJSON = {
    id: uuidv4(),
    label,
    color: pickNewColor(options)
  };

  return { kind: 'new', option, optionId: option.id };
}
